import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  ConfigService,
  EntityParams,
  EntityService
} from 'viggo-sistemas-core-web';
import { IEntityPagination } from 'viggo-sistemas-core-web/modules/core/model/entity.model';
import { IVariacaoMateria } from '../model/variacao-materias.model';

@Injectable()
export class VariacaoMateriaService extends EntityService<IVariacaoMateria> {
  constructor(protected configService: ConfigService) {
    super({
      baseEntityEndPoint: 'variacao_materia',
      urlBackend: configService.backendURL
    });
  }

  /**
   * Pesquisa uma lista de entidades apartir de um parametro repassado
   * @param params parametros repassados
   * @param domainId identificador do domain a ser buscado
   */
  override getEntitiesByParams(
    params: string | EntityParams<IVariacaoMateria>,
    domainId?: string,
    require_pagination = false
  ): Observable<any> {
    let paramsAux: string = null;
    let paramsHttp = new HttpParams();

    if (typeof params === 'string') {
      paramsAux = `?${params}${
        require_pagination ? '&require_pagination=true' : ''
      }`;
      if (domainId) paramsAux += `&domain_id=${domainId}`;
    } else {
      if (params.where) paramsHttp = this.getParams(params.where);
      if (domainId) paramsHttp = paramsHttp.set('domain_id', domainId);
      if (require_pagination) {
        paramsHttp = paramsHttp.set('require_pagination', require_pagination);
      }
      if (params.pagination) {
        paramsHttp = paramsHttp.set('page', params.pagination.page);
        paramsHttp = paramsHttp.set('page_size', params.pagination.page_size);
        if (params.pagination.require_pagination)
          paramsHttp = paramsHttp.set(
            'require_pagination',
            params.pagination.require_pagination
          );
      }
      if (params.include && params.include.length)
        paramsHttp = paramsHttp.set('include', params.include.join(','));
      if (params.order_by && params.order_by.length)
        paramsHttp = paramsHttp.set('order_by', params.order_by.join(','));
      if (params.list_options)
        paramsHttp = paramsHttp.set('list_options', params.list_options);
      paramsAux = null;
    }

    const url = this.baseURL + (paramsAux || '');

    return this.http
      .get<any>(url, {
        headers: this.getHeader(),
        params: paramsHttp
      })
      .pipe(
        map(data => {
          if (
            (typeof params === 'object' &&
              params.pagination &&
              params.pagination.require_pagination) ||
            require_pagination
          ) {
            data = data as IEntityPagination<IVariacaoMateria>;
            data[this.entitiesName].forEach(variacao => {
              if (variacao.itens) {
                const filter = paramsHttp.get('variacao_item.descricao');
                variacao.itens = variacao.itens.filter(it => it.active);
                if (filter)
                  variacao.itens = variacao.itens.filter(it => {
                    var descricao = it.descricao.toUpperCase();
                    if (descricao.includes(filter.split('%')[1].toUpperCase()))
                      return it;
                  });
              }
            });
            return {
              data: data[this.entitiesName],
              pagination: data.pagination
            };
          }
          data = data as IVariacaoMateria[];
          return data[this.entitiesName];
        }),
        catchError(this.handleError)
      );
  }
}
